import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Tape as Tape$2, TapeRow } from './Tape.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

var _excluded = ["color", "firstRow", "secondRow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tape = function Tape(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'sunlight' : _ref$color,
    _ref$firstRow = _ref.firstRow,
    firstRow = _ref$firstRow === void 0 ? null : _ref$firstRow,
    _ref$secondRow = _ref.secondRow,
    secondRow = _ref$secondRow === void 0 ? null : _ref$secondRow,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!firstRow && !secondRow) {
    return false;
  }
  return /*#__PURE__*/jsxs(Tape$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: [firstRow && /*#__PURE__*/jsx(TapeRow, {
      $color: color,
      $firstRow: true,
      children: firstRow
    }), secondRow && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx(TapeRow, {
        children: secondRow
      })]
    })]
  }));
};
var Tape$1 = Tape;

export { Tape$1 as default };
//# sourceMappingURL=Tape.js.map
